import { useMemo } from 'react';
export const useForcedNav = () => {
	const forcedNavKey = useMemo(() => {
		if (typeof window === 'undefined' || process.env['NODE_ENV'] !== 'development') {
			return null;
		}
		try {
			const urlParams = new URLSearchParams(window.location.search);
			const forceNavParam = urlParams.get('forceNav');

			if (forceNavParam !== null) {
				const validNavKeys = ['products', 'ai', 'solutions', 'why-atlassian', 'resources', 'teams'];

				if (validNavKeys.includes(forceNavParam)) {
					return forceNavParam;
				}
			}
		} catch (error) {
			console.log('error not found:', error);
		}
		return null;
	}, []);

	return {
		forcedNavKey,
		isForcingNav: forcedNavKey !== null,
	};
};
